/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_TermInputs */

const id_tld_pricing_column_term = /** @type {(inputs: Tld_Pricing_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa`)
};

const en_tld_pricing_column_term = /** @type {(inputs: Tld_Pricing_Column_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Term`)
};

/**
* | output |
* | --- |
* | "Term" |
*
* @param {Tld_Pricing_Column_TermInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_term = /** @type {((inputs?: Tld_Pricing_Column_TermInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_TermInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_term(inputs)
	return id_tld_pricing_column_term(inputs)
});